<template>
  <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-12">
                <h1 class="text-white pt-3 px-3">จัดการคนเข้ารับ</h1>
                <p
                    class="text-white pb-0 px-3"
                >เปลี่ยน / ตั้งค่าพนักงานเข้ารับของขนส่ง</p>
            </div>
      </div>
    </base-header>
    <div class="text-center" v-if="busy">
        <BlockUI>
            <div class="loader"></div>
        </BlockUI>
    </div>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col">
                <div class="card shadow">
                    <div class="card-header bg-transparent">
                        <div class="row justify-content-between">
                            <div class="col-12 col-md-12 col-lg-12">
                                <b-form-group class="mb-0" >
                                    <div class="row w-100 align-items-end">
                                        <div class="col-12 col-md-12 col-lg-3">
                                            <label for="">เลือกวันที่เริ่มต้น</label>
                                            <input
                                                type="date"
                                                placeholder="dd/mm/yyyy"
                                                class="form-control"
                                                v-model="search.dateStart"
                                            />
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-3">
                                            <label for="">ถึงวันที่</label>
                                            <input
                                                type="date"
                                                placeholder="dd/mm/yyyy"
                                                class="form-control"
                                                v-model="search.dateEnd"
                                            />
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-2">
                                            <b-button class="btn btn-info btn-sm-res" @click="searchingRealTimePickup()">
                                                <i class="fa fa-search"></i>
                                            </b-button>
                                        </div>
                                        <div class="col-12 col-md-12 col-lg-4 text-right">
                                            <button class="btn btn-info btn-sm-res" @click="$bvModal.show('modal-group-input')">
                                            <i class="fas fa-cog"></i>
                                            <span>ตั้งค่าพนักงานเข้ารับประจำ</span>
                                            </button>
                                        </div>
                                    </div>
                                </b-form-group>
                                <hr class="d-md-none d-lg-none" />
                            </div>
                            <div class="col-12 col-md-6 col-lg-12 mb-3">
                                <hr class="d-block d-md-none d-lg-none mb-0" />
                            </div>
                        </div>
                    </div>
                    <div id="tablePrint">
                        <b-table
                            show-empty
                            responsive
                            :items="driver"
                            :fields="fields"
                            :per-page="search.perPage"
                            class="scroll-bar-pop text-center realtime-pickup"
                            empty-text="ไม่มีข้อมูลคนเข้ารับ"
                            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                        >
                            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
                            <template slot="created_at" slot-scope="data">
                                {{ data.item.created_at }}
                            </template>
                            <template slot="courier_code" slot-scope="data">
                                <img :src="getCourierImage(data.item.courier_code)" height="30" alt=""/>
                                <!-- {{data.item.courier_code}} -->
                            </template>
                            <template slot="state" slot-scope="data">
                                <div class="status-wait" v-if="data.item.state === 'allocating'">
                                    รอจัดการ
                                </div>
                                <div class="status-cancel" v-if="data.item.state === 'canceled'">
                                    ยกเลิก
                                </div>
                                <div class="status-cancel" v-if="data.item.state === 'transferred'">
                                    ถูกโอนงาน
                                </div>
                                <div class="status-recieve" v-if="data.item.state === 'pending_pickup'">
                                    รอเข้ารับพัสดุ
                                </div>
                                <div class="status-complete" v-if="data.item.state === 'picked_up'">
                                    เข้ารับพัสดุแล้ว
                                </div>
                            </template>
                            <template slot="origin_address" slot-scope="data">
                                {{ data.item.origin_address.text }}
                            </template>
                            <template slot="courier_info" slot-scope="data">
                                <div class="courier-info">
                                    <div class="text-sm icon-box">
                                        <div v-if="permissionInfo('courier_ticket_pickup_id', data.item.courier_code)" v-b-tooltip title="Booking ID"><i class="fa fa-book"></i></div>
                                        <div v-if="permissionInfo('courier_staff_id', data.item.courier_code)" v-b-tooltip title="รหัสพนักงาน"><i class="fa fa-id-card"></i></div>
                                        <div v-if="permissionInfo('courier_staff_name', data.item.courier_code)" v-b-tooltip title="ชื่อพนักงาน"><i class="fa fa-user"></i></div>
                                        <div v-if="permissionInfo('courier_staff_phone', data.item.courier_code)" v-b-tooltip title="เบอร์โทรพนักงาน"><i class="fa fa-phone"></i></div>
                                        <div v-if="permissionInfo('estimate_at_text', data.item.courier_code)" v-b-tooltip title="เวลาเข้ารับโดยประมาณ"><i class="fa fa-shipping-fast"></i></div>
                                    </div>
                                    <div class="text-sm info-box" >
                                        <div v-if="permissionInfo('courier_ticket_pickup_id', data.item.courier_code) && data.item.courier_ticket_pickup_id">
                                            <a v-if="permissionInfo('courier_ticket_pickup_id', data.item.courier_code) && data.item.courier_ticket_pickup_id" :href="'https://postone.thailandpost.com/pickup/B-'+data.item.courier_ticket_pickup_id" target="_blank">{{ data.item.courier_ticket_pickup_id}}</a>
                                            <span v-else>{{ data.item.courier_ticket_pickup_id || '-'}}</span>
                                        </div>
                                        <div v-if="permissionInfo('courier_staff_id', data.item.courier_code)">{{ data.item.courier_staff_id || '-'}}</div>
                                        <div v-if="permissionInfo('courier_staff_name', data.item.courier_code)">{{ data.item.courier_staff_name || '-' }}</div>
                                        <div v-if="permissionInfo('courier_staff_phone', data.item.courier_code)">{{ data.item.courier_staff_phone || '-' }}</div>
                                        <div v-if="permissionInfo('estimate_at_text', data.item.courier_code)">{{ data.item.estimate_at_text || '-' }}</div>
                                    </div>
                                </div>
                            </template>
                            <template slot="tools" slot-scope="data">
                                <div v-if="permissionAction(data.item.courier_code)">
                                    <b-button variant="outline-primary" v-if="data.item.completed_at" class="btn btn-sm btn-info px-3" disabled>
                                            <i class="fas fa-sync"></i> เปลี่ยนพนักงาน
                                    </b-button>
                                    <b-button variant="outline-primary" v-else-if="data.item.state === 'pending_pickup'" class="btn btn-sm btn-info px-3" @click="openModal('changemodal', data.item.id, null, data.item.origin_address.text)">
                                            <i class="fas fa-sync"></i> เปลี่ยนพนักงาน
                                    </b-button>
                                    <b-button variant="outline-primary" v-else-if="data.item.state === 'allocating'" class="btn btn-sm btn-info px-3" @click="openModal('inputmodal', data.item.id, null, data.item.origin_address.text)">
                                            <i class="fas fa-user"></i> ระบุพนักงาน
                                    </b-button>
                                    <b-button variant="outline-primary" v-else class="btn btn-sm btn-info px-3" disabled>
                                            <i class="fas fa-sync"></i> เปลี่ยนพนักงาน
                                    </b-button>
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </template>
                        </b-table>
                        <div class="mt-3">
                            <b-pagination 
                                :total-rows="totalItem"
                                :current-page="search.page"
                                :per-page="search.perPage"
                                :value="search.totalPages" 
                                @input="handleChangePage"
                                align="right">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-group-driver">
        <b-modal ref="modalGroupDriver" id="modal-group-input" centered hide-footer>
            <template #modal-header="{ close }" >
                <h2 class="m-0">กำหนดพนักงานเข้ารับ</h2>         
                <span class="close cursor-pointer" @click="close('groupInput')">&times;</span>
            </template>

            <template #default="{ close }">
                <div>
                    <p class="warning-text px-2 py-2">
                        <img :src="iconUrl.infoCircle" alt="" class="mr-2">
                        <span>กรณีที่ไม่ได้กำหนดพนักงานเข้ารับ หรือ พนักงานเข้ารับไม่สามารถรับงานได้ ระบบจะทำการจัดสรรพนักงานที่สามารถเข้ารับได้ให้อัตโนมัติ</span>
                    </p>
                    <label class="mt-2">
                        รหัสพนักงาน
                        <!-- <span class="text-danger"> *</span> -->
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="กรอกรหัสพนักงาน"
                        v-model="inputGroup.driverId"
                        :disabled="removeStaffId"
                        :class="{ 'is-invalid bd-danger': $v.inputGroup.driverId.$error }"
                    />
                    <!-- <br/> -->
                    <!-- <p class="text-muted text-sm"><input type="checkbox" v-model="removeStaffId"/> ยกเลิกพนักงานเข้ารับประจำ <i class="fa fa-info-circle" v-b-tooltip title="ยกเลิกพนักงานประจำ ระบบขนส่งจะจัดสรรพนักงานเข้ารับให้อัตโนมัติ"></i></p> -->
                </div>
                <div class="d-flex justify-content-center mt-3">
                    <div>
                        <!-- <b-button variant="outline-primary" @click="close('groupInput')">
                            ยกเลิก
                        </b-button> -->
                        <b-button variant="primary" @click="setStaffId" v-if="!removeStaffId">
                            บันทึก
                        </b-button>
                        <!-- <b-button variant="danger" @click="setStaffId" v-if="removeStaffId">
                            บันทึก
                        </b-button> -->
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
    <div class="modal-driver-change">
        <b-modal ref="modalChangeDriver" id="modal-driver-change" centered hide-footer>
            <template #modal-header="{ close }" >
                <h2 class="m-0">เปลี่ยนพนักงานเข้ารับ</h2>         
                <span class="close cursor-pointer" @click="close('changemodal')">&times;</span>
            </template>
            <template #default="{ close }">
                <div>
                    <p class="warning-text px-2 py-2">
                        <img :src="iconUrl.infoCircle" alt="" class="mr-2">
                        <span>ก่อนทำการเปลี่ยนพนักงานเข้ารับ กรุณาติดต่อพนักงานที่เข้ารับ ณ ปัจจุบันให้ยกเลิกงานก่อนทำการเปลี่ยนพนักงานชื่อพนักงาน : ปวิช วิไลรัตน์ (081-234-5678)</span>
                    </p>
                    <label>
                        ที่อยู่เข้ารับ
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="กรุณากรอกที่อยู่เข้ารับ"
                        :value="shop_convert_address"
                        disabled
                    />
                    <label class="mt-2">
                        รหัสพนักงาน<span class="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="กรอกรหัสพนักงาน"
                        v-model="inputChangeDriver.driverId"
                        :class="{ 'is-invalid bd-danger': $v.inputChangeDriver.driverId.$error }"
                    />
                </div>
                <div class="d-flex justify-content-center mt-3">
                    <div>
                        <b-button variant="outline-primary" @click="close('changemodal')">
                            ย้อนกลับ
                        </b-button>
                        <b-button variant="primary" @click="actionChangeDriver()">
                            เปลี่ยนพนักงาน
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
    <div class="modal-driver-input">
        <b-modal ref="modalInputDriver" id="modal-driver-input" centered hide-footer>
            <template #modal-header="{ close }" >
                <h2 class="m-0">ระบุพนักงาน</h2>         
                <span class="close cursor-pointer" @click="close('inputmodal')">&times;</span>
            </template>
            <template #default="{ close }">
                <div>
                    <p class="warning-text px-2 py-2">
                        <img :src="iconUrl.infoCircle" alt="" class="mr-2">
                        <span>กรณีที่ไม่ได้กำหนดพนักงานเข้ารับ หรือ พนักงานเข้ารับไม่สามารถรับงานได้ ระบบจะทำการจัดสรรพนักงานที่สามารถเข้ารับได้ให้อัตโนมัติ</span>
                    </p>
                    <label>
                        ที่อยู่เข้ารับ
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="กรุณากรอกที่อยู่เข้ารับ"
                        :value="shop_convert_address"
                        disabled
                    />
                    <label class="mt-2">
                        รหัสพนักงาน<span class="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="กรอกรหัสพนักงาน"
                        v-model="inputDriver.driverId"
                        :class="{ 'is-invalid bd-danger': $v.inputDriver.driverId.$error }"
                    />
                </div>
                <div class="d-flex justify-content-center mt-3">
                    <div>
                        <b-button variant="outline-primary" @click="close('inputmodal')">
                            ย้อนกลับ
                        </b-button>
                        <b-button variant="primary" @click="actionInputDriver()">
                            เลือกพนักงาน
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
    <div class="modal-yes-or-no">
        <b-modal ref="modalYesOrNo" id="modal-yes-or-no" hide-header centered hide-footer>
            <template>
                <div class="d-flex align-items-center flex-column justify-content-center mt-3">
                    <div>
                        <img src="../assets/icon/warning.svg" alt="">
                    </div>
                    <p>
                        ท่านยืนยันที่จะเปลี่ยนพนักงานเป็นรหัส <span class="text-primary">{{ tempFormParams['courier_staff_id'] }}</span> หรือไม่ ?
                    </p>
                </div>
                <div class="d-flex justify-content-center mt-3">
                    <div>
                        <b-button variant="outline-primary" @click="close('yesorno')">
                            ย้อนกลับ
                        </b-button>
                        <b-button variant="primary" @click="actionYesOrNo()">
                            ยืนยัน
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
  </div> 
</template>

<script>
import { required } from "vuelidate/lib/validators"
import _ from 'lodash';
import moment from "moment";
export default {
    data() {
        return {
            mounted: false,
            iconUrl: {
                infoCircle: require('../assets/icon/info-driver.svg'),
            },
            courierImage: {},
            courierInfoPermission: {
                'estimate_at_text': ['EMST', 'EMSX', 'EMSXP'],
                'courier_ticket_pickup_id': ['EMST', 'EMSX', 'EMSXP'],
                'courier_staff_name': ['FLE', 'FLEB', 'FLEF'],
                'courier_staff_phone': ['FLE', 'FLEB', 'FLEF'],
                'courier_staff_id': ['FLE', 'FLEB', 'FLEF'],
            },
            busy: false,
            driver: [],
            totalItem: 20,
            removeStaffId: false,
            search: {
                dateStart:  moment().format('yyyy-MM-DD 00:00:00'),
                dateEnd: moment().format('yyyy-MM-DD 23:59:59'),
                perPage: '',
                page: 1,
                totalPages: '',
            },
            inputGroup: {
                driverId: ''
            },
            inputChangeDriver: {
                address: '',
                driverId: '',
                remark: '',
            },
            inputDriver: {
                address: '',
                driverId: '',
                remark: '',
            },
            tempPickupId: '',
            tempModalKey: '',
            tempFormParams: {
                courier_staff_id: '',
                courier_pickup_id: ''
            },
            shop_address: {},
            shop_convert_address: "",
            origin_id: null,
        }
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "created_at", label: "วันที่เรียกรถเข้ารับ ", sortable: true },
                { key: "courier_code", label: "ขนส่ง ", sortable: true },
                { key: "state", label: "สถานะการเข้ารับ" },
                { key: "origin_address", label: "ที่อยู่ต้นทาง" },
                { key: "courier_info", label: "ข้อมูลขนส่ง"},
                { key: "tools", label: "การจัดการ" }
            ]
            return fields
        }
    },
    validations: {
        inputGroup: {
            driverId: { required },
        },
        inputDriver: {
            driverId: { required }
        },
        inputChangeDriver: {
            driverId: { required }
        }
    },
    methods: {
        getOverAllIndex(index) {
            return ( this.search.page * 20 ) - 20 + index + 1
        },
        permissionInfo(field, courierCode) {
            console.log('permission', field, courierCode)
            return this.courierInfoPermission[field].includes(courierCode)?true:false;
        },
        permissionAction(courierCode) {
            return ['FLE', 'FLEB', 'FLEF'].includes(courierCode);
        },
        async fetchManageDriver(page = null) {
            return new Promise((resolve, reject) => {
                    
                this.busy = true
                const headers = {
                    headers: {
                        Token: localStorage.getItem('access_token')
                    }
                }
            
                const startTime = this.search.dateStart ? new Date(this.search.dateStart) : null;
                const endTime = this.search.dateEnd ? new Date(this.search.dateEnd) : null;
                console.log('fetch', startTime, endTime);
                let startISO = null;
                let endISO = null;
            
                if (startTime) {
                    startTime.setHours(startTime.getHours() + 7);
                    startISO = startTime.toISOString().substring(0, 10) + ' 00:00:00';
                }
                if (endTime) {
                    endTime.setHours(endTime.getHours() + 7);
                    endTime.setHours(23, 59, 59, 999);
                    endISO = endTime.toISOString().substring(0, 10) + ' 23:59:59';
                }
                const bodyJson = {
                    "page": page === null ? 1 : page,
                    "created_at": {
                        "start": startISO,
                        "end": endISO,
                    },
                    "courier_codes": ["FLE", "FLEB", "FLEF", "EMST", "EMSXP", "EMSX"],
                    "origin_ids": [this.origin_id]
                }
                _.forEach(["FLE", "FLEB", "FLEF", "EMST", "EMSXP", "EMSX"], (element, index )=> {
                    this.getCourierImage(element);
                });
                
                this.$http.post(this.$API_URL + '/driver/get', bodyJson, headers).then((res) => {
                    this.driver = res.data.data.data.items;
                    this.totalItem = res.data.data.data.total
                    this.search.perPage = res.data.data.data.perpage
                    this.search.page = res.data.data.data.page
                    this.search.total = res.data.data.data.total
                    resolve();
                }).finally(() => {
                    this.busy = false
                    resolve();
                })

            })
        },
        searchingRealTimePickup() {
            this.fetchManageDriver(this.search.page)
        },
        openModal(key, pickupId, form_params = null, origin_adress = '') {
            if(key === 'changemodal') {
                this.$bvModal.show('modal-driver-change')
                this.tempPickupId = pickupId
                this.tempModalKey = key 
                this.shop_convert_address = origin_adress
            }else if (key === 'inputmodal') {
                this.$bvModal.show('modal-driver-input')
                this.tempPickupId = pickupId
                this.tempModalKey = key 
                this.shop_convert_address = origin_adress
            }else if (key === 'yesorno') {
                this.tempFormParams = form_params
                this.$bvModal.show('modal-yes-or-no')
            }else if (key === 'groupInput') {
                this.$bvModal.hide('modal-group-input')
            }
        },
        updateDriver(courier) {
            this.busy = true
            const headers = {
                headers: {
                    Token: localStorage.getItem('access_token')
                }
            }
            const bodyJson = {
                courier_staff_id: parseInt(courier.courier_staff_id),
                courier_pickup_id: courier.courier_pickup_id,
            }
            this.$http.post(this.$API_URL + '/driver/update', bodyJson, headers).then((res) => {
                const status = res.data.data.status
                if (!status) {
                    this.showErrorModal('เกิดข้อผิดพลาดกรุณาติดต่อเจ้าหน้าที่')
                }
            }).finally(() => {
                this.fetchManageDriver()
                this.busy = false
            })

        },
        handleChangePage(page) {
            if (this.mounted) {
              this.changePage(page);
            }
        },
        changePage(page) {
            this.fetchManageDriver(page)
        },
        async actionYesOrNo() {
            await this.updateDriver(this.tempFormParams)
            this.closeAllModal()
            await this.clearInput()
        },
        closeAllModal() {
            this.$bvModal.hide('modal-yes-or-no')
            this.$bvModal.hide('modal-driver-change')
            this.$bvModal.hide('modal-driver-input')
        },
        actionInputDriver() {
          this.$v.inputDriver.$touch();
          if (this.$v.inputDriver.$invalid) {
            return false
          }
          const form_params = {
              courier_staff_id: this.inputDriver.driverId,
              courier_pickup_id: this.tempPickupId
          }
          this.openModal('yesorno', '', form_params)
        },
        actionChangeDriver() {
          this.$v.inputChangeDriver.$touch();
          if (this.$v.inputChangeDriver.$invalid) {
            return false
          }
          const form_params = {
              courier_staff_id: this.inputChangeDriver.driverId,
              courier_pickup_id: this.tempPickupId
          }
          this.openModal('yesorno', '', form_params)
        },
        async callShopDetail() {
            const headers = {
                headers: {
                    Token: localStorage.getItem('access_token')
                }
            }
            await this.$http.get(this.$API_URL + '/shop/shop/0', headers).then((res) => {
                this.shop_address = res.data.data[0].address_from
                console.log('shop_address: ', this.shop_address)
            })
        },
        returnAddressShop() {
            const { address, state, district, province, postcode, tel } = this.shop_address;
            this.shop_convert_address = `${address} ${state} ${district} ${province} ${postcode} ${tel}`
            console.log('this.shop_convert_address: ', this.shop_convert_address)
        },
        getCourierImage(courierCode) {
            // return new Promise((resolve, reject) => {
                if (this.courierImage[courierCode]) {
                    console.log('ret cache image', this.courierImage[courierCode]);
                    return this.courierImage[courierCode];
                }
                const storageRef = this.$firebase.storage().ref(`/icon/${courierCode}.png`).getDownloadURL()
                storageRef.then(res => {
                    this.courierImage[courierCode] = res;
                    return res;
                }).catch(() => {
                    this.courierImage[courierCode] = "/img/brand/load-error.svg"
                    return this.courierImage[courierCode];
                })
            // })
            
            // return url;
        },
        clearInput() {
            this.tempPickupId = ''
            this.tempModalKey = ''
            this.tempStaffId = ''
            this.inputChangeDriver = {
                address: '',
                driverId: '',
                remark: '',
            }
            this.inputDriver = {
                address: '',
                driverId: '',
                remark: '',
            }
        },
        close(key) {
            if(key === 'inputmodal') {
                this.$bvModal.hide('modal-driver-input')
                this.clearInput()
            }else if(key === 'changemodal') {
                this.$bvModal.hide('modal-driver-change')
                this.clearInput()
            }else if(key === 'yesorno') {
                this.$bvModal.hide('modal-yes-or-no')
            }else if(key === 'groupInput') {
                this.$bvModal.hide('modal-group-input')
            }
        },
        async getOrigin() {
            const header = {
                headers: {
                    Token: localStorage.getItem('access_token')
                }
            }
            // TODO: ดักไว้ก่อนเพื่อร้าน ไม่มี origin_id
            await this.$http.post(this.$API_URL + '/driver/get/origin', {}, header).then((res) => {
                this.shop_address = res.data.data.address ? res.data.data.address : this.callShopDetail()
                this.origin_id = this.shop_address.origin_id
            })
        },
        setStaffId() {
            // if (this.removeStaffId) {
            //     this.inputGroup.driverId = '';
            // } else {
            //     this.$v.inputGroup.$touch();
            //     if (this.$v.inputGroup.$invalid) {
            //     return false
            //     }
            // }
            const headers = {
                headers: {
                    Token: localStorage.getItem('access_token')
                }
            }
            const bodyJson = {
                flash_staff_id: this.inputGroup.driverId,
            }
            this.$http.post(this.$API_URL + '/driver/set/flash/staffid', bodyJson, headers).then((res) => {
                if(!res.data.status) {
                    this.showErrorModal('เกิดข้อผิดพลาดไม่สามารถตั้งค่ารหัสพนักงานได้')
                }
                this.$bvModal.hide('modal-group-input')

            })
        },
        getStaffId() {
            const headers = {
                headers: {
                    Token: localStorage.getItem('access_token')
                }
            }
            this.$http.post(this.$API_URL + '/driver/get/flash/staffid', {}, headers).then((res) => {
                this.inputGroup.driverId = res.data.data ? res.data.data : ''
            })
        }
    },
    async mounted() {
        await this.getOrigin()
        this.getStaffId()
        this.returnAddressShop()
        await this.fetchManageDriver()
        this.mounted = true
    }
}
</script>

<style lang="scss" scoped>
.warning-text {
    background: #FAF1CB;
}
.status-complete {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    gap: 10px;
    width: 100px;
    height: 30px;
    background: rgba(217, 243, 201, 0.65);
    border-radius: 3px;
    color: #4EC217;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0.2px;
}
.status-wait {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    gap: 10px;
    width: 100px;
    height: 30px;
    background: rgba(243, 241, 201, 0.65);
    border-radius: 3px;
    color: #E8AB0E;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0.2px;
}
.status-cancel {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    gap: 10px;
    width: 100px;
    height: 30px;
    background: rgba(243, 211, 201, 0.65);
    border-radius: 3px;
    color: #E8290E;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0.2px;
}
.status-recieve {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    gap: 10px;
    width: 100px;
    height: 30px;
    background: rgba(243, 241, 201, 0.65);
    border-radius: 3px;
    color: #E8AB0E;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0.2px;
}
</style>